module.exports = __webpack_public_path__ + "static/logo-clevercanary-1419e2a7de534d4a582ba1c1cf786f20.png";